/*!

=========================================================
* Soft UI Design System 3 PRO - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-design-system
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Function for smooth scroll to element
function smoothToPricing(id) {
  if (document.getElementById(id)) {
    document.getElementById(id).scrollIntoView({
      behavior: 'smooth'
    });
  }
}

// Debounce function
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
};

// initialization of Popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})

// initialization of Tooltips
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})

// helper for adding on all elements multiple attributes
function setAttributes(el, options) {
  Object.keys(options).forEach(function (attr) {
    el.setAttribute(attr, options[attr]);
  })
}

// activate popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})

// activate tooltips
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})


window.onload = function () {
  // Material Design Input function
  var inputs = document.querySelectorAll('input');

  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('focus', function (e) {
      this.parentElement.classList.add('is-focused');
    }, false);

    inputs[i].onkeyup = function (e) {
      if (this.value != "") {
        this.parentElement.classList.add('is-filled');
      } else {
        this.parentElement.classList.remove('is-filled');
      }
    };

    inputs[i].addEventListener('focusout', function (e) {
      if (this.value != "") {
        this.parentElement.classList.add('is-filled');
      }
      this.parentElement.classList.remove('is-focused');
    }, false);
  }

  // Ripple Effect
  var ripples = document.querySelectorAll('.btn');

  for (var i = 0; i < ripples.length; i++) {
    ripples[i].addEventListener('click', function (e) {
      var targetEl = e.target;

      // Skip ripple if button has data-no-ripple attribute
      if (targetEl.getAttribute('data-no-ripple') === 'true') {
        return;
      }

      var rippleDiv = targetEl.querySelector('.ripple');

      rippleDiv = document.createElement('span');
      rippleDiv.classList.add('ripple');
      rippleDiv.style.width = rippleDiv.style.height = Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px';
      targetEl.appendChild(rippleDiv);

      rippleDiv.style.left = (e.offsetX - rippleDiv.offsetWidth / 2) + 'px';
      rippleDiv.style.top = (e.offsetY - rippleDiv.offsetHeight / 2) + 'px';
      rippleDiv.classList.add('ripple');
      setTimeout(function () {
        // Safety check to prevent errors when DOM is removed during navigation
        if (rippleDiv && rippleDiv.parentElement) {
          rippleDiv.parentElement.removeChild(rippleDiv);
        }
      }, 600);
    }, false);
  }
};

// Multi Level Dropdown
function dropDown(a) {
  if (!document.querySelector('.dropdown-hover')) {
    event.stopPropagation();
    event.preventDefault();
    var multilevel = a.parentElement.parentElement.children;


    for (var i = 0; i < multilevel.length; i++) {
      if (multilevel[i].lastElementChild != a.parentElement.lastElementChild) {
        multilevel[i].lastElementChild.classList.remove('show');
        multilevel[i].firstElementChild.classList.remove('show');
      }
    }

    if (!a.nextElementSibling.classList.contains("show")) {
      a.nextElementSibling.classList.add("show");
      a.classList.add("show");

    } else {
      a.nextElementSibling.classList.remove("show");
      a.classList.remove("show");

    }
  }
}

// Colored shadows from Cards
if (document.querySelector('.blur-shadow-image')) {
  var shadowCards = document.querySelectorAll('.blur-shadow-image');
  var shadowCardsRounded = document.querySelectorAll('.blur-shadow-image.rounded-circle');

  if (shadowCardsRounded) {
    for (var i = 0; i < shadowCardsRounded.length; i++) {
      var div = document.createElement("DIV");
      shadowCardsRounded[i].parentElement.appendChild(div);
      div.classList.add('colored-shadow', 'rounded');

      var currentSrc = shadowCardsRounded[i].children[0].getAttribute('src');
      var el = shadowCardsRounded[i].nextElementSibling;

      el.style.backgroundImage = 'url(' + currentSrc + ')';
    }
  }
  if (shadowCards) {
    for (var i = 0; i < shadowCards.length; i++) {
      var div = document.createElement("DIV");
      shadowCards[i].parentElement.appendChild(div);
      div.classList.add('colored-shadow');

      var currentSrc = shadowCards[i].children[0].getAttribute('src');
      var el = shadowCards[i].nextElementSibling;

      el.style.backgroundImage = 'url(' + currentSrc + ')';
    }
  }
}

// Colored shadows for Avatars
if (document.querySelector('.blur-shadow-avatar')) {
  var shadowCards = document.querySelectorAll('.blur-shadow-avatar');
  var shadowCardsRounded = document.querySelectorAll('.blur-shadow-avatar.rounded-circle');

  if (shadowCardsRounded) {
    for (var i = 0; i < shadowCardsRounded.length; i++) {

      var div = document.createElement("DIV");
      shadowCardsRounded[i].parentElement.appendChild(div);
      div.classList.add('colored-shadow', 'rounded', 'start-0', 'end-0', 'mx-auto');

      var avatarClasses = ['avatar-xs', 'avatar-sm', 'avatar-lg', 'avatar-xl', 'avatar-xxl'];

      for (var k = 0; k < avatarClasses.length; k++) {
        if (shadowCardsRounded[i].firstElementChild.classList.contains(avatarClasses[k])) {
          div.classList.add(avatarClasses[k]);
        }
      }

      var currentSrc = shadowCardsRounded[i].children[0].getAttribute('src');
      var el = shadowCardsRounded[i].nextElementSibling;

      el.style.backgroundImage = 'url(' + currentSrc + ')';
    }
  }
  if (shadowCards) {

    for (var i = 0; i < shadowCards.length; i++) {

      var div = document.createElement("DIV");
      shadowCards[i].parentElement.appendChild(div);
      div.classList.add('colored-shadow', 'start-0', 'end-0', 'mx-auto');

      var avatarClasses = ['avatar-xs', 'avatar-sm', 'avatar-lg', 'avatar-xl', 'avatar-xxl'];

      for (var k = 0; k < avatarClasses.length; k++) {
        if (shadowCards[i].firstElementChild.classList.contains(avatarClasses[k])) {
          div.classList.add(avatarClasses[k]);
        }
      }

      var currentSrc = shadowCards[i].children[0].getAttribute('src');
      var el = shadowCards[i].nextElementSibling;

      el.style.backgroundImage = 'url(' + currentSrc + ')';
    }
  }
}

//Google Maps
if (document.querySelector('#google-maps')) {
  var myLatlng = new google.maps.LatLng(40.748817, -73.985428);
  var mapOptions = {
    zoom: 13,
    center: myLatlng,
    scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
    styles: [{
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#444444"
      }]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [{
        "color": "#f2f2f2"
      }]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      }, {
        "lightness": 45
      }]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [{
        "visibility": "simplified"
      }]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [{
        "color": "#C5CBF5"
      }, {
        "visibility": "on"
      }]
    }
    ]
  };

  var map = new google.maps.Map(document.getElementById("google-maps"), mapOptions);

  var marker = new google.maps.Marker({
    position: myLatlng,
    title: "Hello World!"
  });

  // To add the marker to the map, call setMap();
  marker.setMap(map);
}

// Tabs navigation

var total = document.querySelectorAll('.nav-pills');

function initializeMovingTab(item) {
  // Remove existing moving tab if any
  const existingTab = item.querySelector('.moving-tab');
  if (existingTab) {
    existingTab.remove();
  }

  // Find the active or first tab
  const activeTab = item.querySelector('.nav-link.active');
  const firstTab = item.querySelector('li:first-child .nav-link');
  const targetTab = activeTab || firstTab;

  if (!targetTab) {
    console.warn('No target tab found for moving tab initialization');
    return null;
  }

  // Get the parent li element for width calculation
  const targetLi = targetTab.closest('li');
  if (!targetLi) {
    console.warn('No parent li found for tab');
    return null;
  }

  // Create moving tab element
  const moving_div = document.createElement('div');
  const tab = targetTab.cloneNode();
  tab.innerHTML = "-";

  moving_div.classList.add('moving-tab', 'position-absolute', 'nav-link');
  moving_div.appendChild(tab);

  // Calculate dimensions based on container and number of tabs
  const containerWidth = item.offsetWidth;
  const totalTabs = item.querySelectorAll('li.nav-item').length;
  const gap = 10; // Match the gap from CSS
  const availableWidth = containerWidth - (gap * (totalTabs - 1));
  const tabWidth = availableWidth / totalTabs;

  // Set initial styles
  moving_div.style.cssText = `
    padding: 0px;
    width: ${tabWidth}px;
    transform: translate3d(0px, 0px, 0px);
    transition: all 0.5s ease;
  `;

  item.appendChild(moving_div);

  // Calculate position
  let sum = 0;
  const nodes = Array.from(targetLi.closest('ul').children);
  const index = nodes.indexOf(targetLi);

  if (item.classList.contains('flex-column')) {
    const tabHeight = targetLi.offsetHeight;
    for (let j = 0; j < index; j++) {
      sum += nodes[j].offsetHeight || 0;
    }
    moving_div.style.transform = `translate3d(0px, ${sum}px, 0px)`;
    moving_div.style.height = `${tabHeight}px`;
  } else {
    sum = index * (tabWidth + gap);
    moving_div.style.transform = `translate3d(${sum}px, 0px, 0px)`;
  }

  return moving_div;
}

total.forEach(function (item, i) {
  let moving_div = initializeMovingTab(item);
  if (!moving_div) return;

  item.addEventListener('click', function (event) {
    const target = event.target;
    const li = target.closest('li');
    if (!li) return;

    // Calculate dimensions based on container and number of tabs
    const containerWidth = item.offsetWidth;
    const totalTabs = item.querySelectorAll('li.nav-item').length;
    const gap = 10; // Match the gap from CSS
    const availableWidth = containerWidth - (gap * (totalTabs - 1));
    const tabWidth = availableWidth / totalTabs;

    const nodes = Array.from(li.closest('ul').children);
    const index = nodes.indexOf(li);

    let sum = 0;
    if (item.classList.contains('flex-column')) {
      const tabHeight = li.offsetHeight;
      for (let j = 0; j < index; j++) {
        sum += nodes[j].offsetHeight || 0;
      }
      moving_div.style.height = `${tabHeight}px`;
      moving_div.style.transform = `translate3d(0px, ${sum}px, 0px)`;
    } else {
      sum = index * (tabWidth + gap);
      moving_div.style.transform = `translate3d(${sum}px, 0px, 0px)`;
    }

    moving_div.style.width = `${tabWidth}px`;
  });
});

// Tabs navigation resize (var: safe if script is re-eval'd via modal .load())
var resizeTimeout;
window.addEventListener('resize', function (event) {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    total.forEach(function (item) {
      const moving_div = item.querySelector('.moving-tab');
      if (moving_div) {
        const newMovingDiv = initializeMovingTab(item);
      }
    });
  }, 100);
});

function getEventTarget(e) {
  e = e || window.event;
  return e.target || e.srcElement;
}

// End tabs navigation


// Copy code function

function copyCode(el) {
  const selection = window.getSelection();
  const range = document.createRange();
  const textToCopy = el.nextElementSibling;
  range.selectNodeContents(textToCopy);
  selection.removeAllRanges();
  selection.addRange(range);
  const successful = document.execCommand('copy');
  window.getSelection().removeAllRanges()
  if (!el.parentElement.querySelector('.alert')) {
    var alert = document.createElement('div');
    alert.classList.add('alert', 'alert-success', 'position-absolute', 'top-0', 'border-0', 'text-white', 'w-25', 'end-0', 'start-0', 'mt-2', 'mx-auto', 'py-2');
    alert.style.transform = 'translate3d(0px, 0px, 0px)'
    alert.style.opacity = '0';
    alert.style.transition = '.35s ease';
    setTimeout(function () {
      alert.style.transform = 'translate3d(0px, 20px, 0px)';
      alert.style.setProperty("opacity", "1", "important");
    }, 100);
    alert.innerHTML = "Code successfully copied!";
    el.parentElement.appendChild(alert);
    setTimeout(function () {
      alert.style.transform = 'translate3d(0px, 0px, 0px)'
      alert.style.setProperty("opacity", "0", "important");
    }, 2000);
    setTimeout(function () {
      el.parentElement.querySelector('.alert').remove();
    }, 2500);
  }
}

// End copy code function

// Enhanced Tabs navigation for wallet
function initializeWalletTabs() {
  document.addEventListener('DOMContentLoaded', function () {
    const navWrapper = document.querySelector('.nav-wrapper');
    if (!navWrapper) return;

    const tabList = navWrapper.querySelector('.nav-pills');
    const movingTab = navWrapper.querySelector('.moving-tab');

    if (!tabList || !movingTab) return;

    function updateMovingTab(activeTab) {
      if (!movingTab || !activeTab) return;

      const allTabs = Array.from(navWrapper.querySelectorAll('.nav-link[data-bs-toggle="tab"]'));
      const index = allTabs.indexOf(activeTab);

      if (index === -1) return;

      // Update data attribute for position
      movingTab.setAttribute('data-tab-position', index.toString());

      // Remove any inline styles that might interfere
      const inlineStyles = ['width', 'transform', 'transition', 'padding'];
      inlineStyles.forEach(style => movingTab.style.removeProperty(style));

      // Clear any existing content
      movingTab.innerHTML = '';
    }

    // Set initial active tab
    const activeTab = navWrapper.querySelector('.nav-link[data-bs-toggle="tab"].active') ||
      navWrapper.querySelector('.nav-link[data-bs-toggle="tab"]');

    if (activeTab) {
      const allTabs = navWrapper.querySelectorAll('.nav-link[data-bs-toggle="tab"]');
      allTabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
        if (t.classList.contains('text-dark')) {
          t.classList.remove('text-dark');
        }
      });
      activeTab.classList.add('active');
      activeTab.setAttribute('aria-selected', 'true');
      updateMovingTab(activeTab);
    }

    // Handle tab clicks using event delegation
    tabList.addEventListener('click', function (event) {
      const tab = event.target.closest('.nav-link[data-bs-toggle="tab"]');
      if (!tab) return;

      event.preventDefault();

      const allTabs = navWrapper.querySelectorAll('.nav-link[data-bs-toggle="tab"]');
      allTabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
        if (t.classList.contains('text-dark')) {
          t.classList.remove('text-dark');
        }
      });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      // Show the corresponding tab content
      const targetId = tab.getAttribute('href');
      if (targetId) {
        const tabContents = document.querySelectorAll('.tab-pane');
        tabContents.forEach(content => {
          content.classList.remove('show', 'active');
        });
        const targetContent = document.querySelector(targetId);
        if (targetContent) {
          targetContent.classList.add('show', 'active');
        }
      }

      updateMovingTab(tab);
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        const currentActive = navWrapper.querySelector('.nav-link[data-bs-toggle="tab"].active');
        if (currentActive) {
          updateMovingTab(currentActive);
        }
      }, 100);
    });

    // Initial cleanup of moving tab
    movingTab.innerHTML = '';
  });
}

// Initialize wallet tabs
initializeWalletTabs();